export const actions = {
	bulkActions: [],
	rowActions: []
};

export default actions;
